<app-table
  #tableComponent
  (rowSelected)='onRowSelected($event)'
  *ngIf='tableReady'
  [columns]='tableColumns'
  [dataSourceParams]='tableDataSourceParams'
  [dataSource]='dataSource'
  [filters]='tableFilters'
  [forceSelectPage]='preselectAllContacts'
  [preselectedIdentifier]="'contact_id'"
  [preselected]='preselectedContactIds'
  [selectable]='true'
  [showPagination]='false'></app-table>
